// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ic-link[data-v-2db7427e] {\n  color: #1890ff;\n  cursor: pointer;\n}\n.ic-link[data-v-2db7427e]:hover {\n  color: #40a9ff;\n  text-decoration: underline;\n}\n.attachment--yes[data-v-2db7427e] {\n  color: #52c41a;\n  font-weight: bold;\n}\n.attachment--no[data-v-2db7427e] {\n  color: #8b0000;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
